export type SubjectType = {
  id: string,
  name: string,
  shortName: string,
  preRequisites: string[],
  postRequisites: string[],
  credits: number,
  schedule: string,
  difficultyLevel: string,
  evaluationStyle: string,
  teachers: string,
  availability: string,
  advice: string,
  curriculum: string,
}

export const mandatories: SubjectType[] = [
  {
    id: '',
    name: '',
    shortName: '',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ICP131',
    name: 'Programação de Computadores I',
    shortName: 'Comp I',
    preRequisites: [],
    postRequisites: ['ICP141', 'ICP143', 'ICP238', 'ICP362', 'ICP027', 'ICP638'],
    credits: 4.0,
    curriculum: 'Resolução de problemas de forma algorítmica; Funções e modularização; Recursão; Variáveis, expressões; Controle de fluxo e repetições; Tipos básicos e estruturados; Tipos abstratos de dados; Vetores e matrizes; Cadeias de caracteres; Documentação, legibilidade, manutenção e eficiência de programas.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Provas, trabalhos, apresentações, listas.',
    teachers: 'Ronald Chiesse',
    advice: 'Não costuma ser muito complicada, mas é sempre bom praticar o que se aprende em aula.',
    availability: 'Baixa',
    schedule: 'Seg-Qua 13h-15h',
  },
  {
    id: 'ICP132',
    name: 'Processos de Software',
    shortName: 'Proc Sof',
    preRequisites: [],
    postRequisites: ['ICP143', 'ICP237', 'ICP038'],
    credits: 4.0,
    curriculum: 'Conceitos de organização, sistema e sistema de informação; Processos de Negócio (Modelagem de Processos (BPMN)); Introdução a Engenharia de Software (Conceito de Partes Interessadas, Valor e Qualidade de Software); Processo de Software (Requisitos, Modelagem, Projeto de software, Implementação, Testes, Manutenção); Conceitos de no-code programming.',
    difficultyLevel: '2/5',
    evaluationStyle: 'Trabalhos, apresentações',
    teachers: 'Juliana França',
    advice: 'A segunda mais tranquila do primeiro período, não precisa ter medo.',
    availability: 'Baixa',
    schedule: 'Ter-Qui 13h-15h',
  },
  {
    id: 'ICP133',
    name: 'Fund de Sistemas de Computação',
    shortName: 'FSC',
    preRequisites: [],
    postRequisites: ['ICP143', 'ICP238', 'ICP246', 'ICP362'],
    credits: 4.0,
    curriculum: 'Organização dos sistemas de computação unitários e distribuídos; Inicialização e finalização do sistema de computação; Caminho percorrido por um programa; Representação, processamento e armazenamento digital de dados (sistemas de numeração, representação de caracteres, áudio e imagem, álgebra booleana, circuitos lógicos, representação e aritmética de números inteiros e reais); Codificação, envio, transmissão e recepção de dados digitais em redes de computadores.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Silvana Rossetto',
    advice: 'Pode ser difícil se for a sua primeira vez vendo este conteúdo, recomenda-se rever as aulas e pesquisar conteúdo no youtube.',
    availability: 'Baixa',
    schedule: 'Ter-Qui 15h-17h',
  },
  {
    id: 'ICP134',
    name: 'Números Inteiros Criptografia',
    shortName: 'Num Int',
    preRequisites: [],
    postRequisites: ['ICP144', 'ICP027', 'ICP638', 'ICP639'],
    credits: 4.0,
    curriculum: 'Divisão de inteiros e algoritmo euclidiano. Primos e o teorema da fatoração única. Indução e recursão. Aritmética modular e teorema de Fermat. Testes de primalidade. Criptografia RSA.',
    difficultyLevel: '5/5',
    evaluationStyle: 'Provas, listas',
    teachers: 'Daniel Chicayban',
    advice: 'Matéria mais complicada do primeiro período, estuda y estuda, nunca deixe de perguntar e de refazer questão, se for o Hugo dando a matéria conte a compaixão dele.',
    availability: 'Alta',
    schedule: 'Ter-Qui 10h-12h',
  },
  {
    id: 'ICP135',
    name: 'Projeto de Carreira',
    shortName: 'Proj Car',
    preRequisites: [],
    postRequisites: ['ICP145'],
    credits: 4.0,
    curriculum: 'Identidade Profissional: Relações entre formação e carreira profissional; Perfis profissionais na área de computação e identidade profissional; Plano de carreira. Comunicação profissional: comunicação e contexto-leitura, compreensão e escrita de textos técnicos/acadêmicos; Autorregulação da Aprendizagem: Projetos de aprendizagem; Aprendizagem universitária; Gestão de tempo. Cidadania e dimensões do trabalho: o trabalho e a sociedade; Ética, sociedade e trabalho; Legislação-aspectos individuais.',
    difficultyLevel: '1/5',
    evaluationStyle: 'Trabalhos, apresentações',
    teachers: 'Maria Luiza (Veteranos), Eldanae (Calourous)',
    advice: 'Matéria mais tranquila do primeiro período, basicamente fazer todos os trabalhos e treinar apresentações que você consegue sair com uma nota alta.',
    availability: 'Alta',
    schedule: 'Seg-Qua 13h-15h (Veteranos) / Seg-Qua 15h-17h (Calouros)',
  },
  {
    id: 'ICP136',
    name: 'Introd Pensamento Dedutivo',
    shortName: 'IPD',
    preRequisites: [],
    postRequisites: ['ICP115'],
    credits: 4.0,
    curriculum: 'Conjuntos e suas operações; conceitos básicos de lógica; definição, teorema e demonstração; medidas de comprimento e área; teorema de Pitágoras e áreas; congruência e semelhança de triângulos; aplicações de geometria plana; irracionalidade de √2 e números reais; coordenadas no plano; função, domínio e imagem; circunferência; trigonometria; funções linear e quadrática; gráficos de funções; funções polinomiais;raízes e divisão de polinômios; exponencial e logaritmo.',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas, listas',
    teachers: 'Severino Collier',
    advice: 'Basicamente pré-cálculo, essa e cripto se complementam, estude bastante.',
    availability: 'Alta',
    schedule: 'Seg-Qua 10h-12h (Talvez tenha de 8h-10h na quarta também)',
  },
  {
    id: 'ICP141',
    name: 'Programação de Computadores II',
    shortName: 'Comp II',
    preRequisites: ['ICP131'],
    postRequisites: ['ICP116', 'ICP237', 'ICP239', 'ICP246', 'ICP123', 'ICP081', 'ICP082', 'ICP083', 'ICP084', 'ICP085'],
    credits: 4.0,
    curriculum: 'Pesquisa sequencial e pesquisa binária; Ordenação por inserção e por seleção; Ponteiros e alocação dinâmica de memória; Estruturas de dados lineares: listas, pilhas e filas; Persistência de dados com arquivos; Noções de complexidade de algoritmos.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Giseli Rabello',
    advice: 'Continuação de Prog I, mesma coisa.',
    availability: 'Baixa',
    schedule: 'Qua-Sex 8h-10h',
  },
  {
    id: 'ICP142',
    name: 'Organização de Dados I',
    shortName: 'Org Dados I',
    preRequisites: [],
    postRequisites: ['ICP603'],
    credits: 2.0,
    curriculum: 'Tipos de dados: dado bruto, dado agregado, dado primário, dado secundário, estruturado, semi e não estruturado, etc.; Ciclo de vida do dado: geração, coleta, tratamento, exploração e visualização; Valor do dado: interoperabilidade e reuso; Dado e metadado; Conceito de Transparência e Privacidade, Legislação associada; Engenharia e Ciência de Dados no apoio a gestão de dados nas organizações.',
    difficultyLevel: '1/5',
    evaluationStyle: 'Apresentações, trabalhos',
    teachers: 'Jonice De Oliveira',
    advice: 'Outra matéria pra você ficar tranquilo.',
    availability: 'Baixa',
    schedule: 'Ter 10h-12h',
  },
  {
    id: 'ICP143',
    name: 'Projeto Prático',
    shortName: 'Proj Prat',
    preRequisites: ['ICP131', 'ICP132', 'ICP133'],
    postRequisites: [],
    credits: 2.0,
    curriculum: 'Conceitos básicos para o desenvolvimento de um projeto de software aplicado.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Trabalhos',
    teachers: 'Gabriel Pereira',
    advice: 'Antigo CL, estude pela internet.',
    availability: 'Baixa',
    schedule: 'Ter 13h-15h',
  },
  {
    id: 'ICP144',
    name: 'Matemática Discreta',
    shortName: 'Mat Disc',
    preRequisites: ['ICP134'],
    postRequisites: ['ICP115', 'ICP123', 'ICP368', 'ICP035', 'ICP036'],
    credits: 4.0,
    curriculum: 'Contagem: Revisão sobre permutações, combinações e arranjos. Princípio de inclusão e exclusão. Números binomiais. Triângulo de Pascal. Números de Fibonacci e recorrências lineares de segunda ordem. Grafos: definição; grau de um vértice; caminhos, ciclos e conectividade; caminhos de Euler e ciclos hamiltonianos; árvores; contagem de árvores; grafos bipartidos e aplicações; grafos planares e a fórmula de Euler; coloração de mapas e grafos; teorema das cinco cores.',
    difficultyLevel: '5/5',
    evaluationStyle: 'Provas',
    teachers: 'Hugo Nobrega',
    advice: 'Provavelmente você já viu algum meme sobre discrete maths. Essa matéria é o porque',
    availability: 'Média',
    schedule: 'Ter-Qui 8h-10h',
  },
  {
    id: 'ICP145',
    name: 'Habilidades Sociais p Trabalho',
    shortName: 'Hab Soc',
    preRequisites: ['ICP135'],
    postRequisites: ['ICP249', 'ICP029'],
    credits: 2.0,
    curriculum: 'Relações e contexto profissional: Psicologia das organizações e relações profissionais. Liderança, delegação e colaboração; Comunicação profissional; Relações sociais e vida virtual. Comunicação profissional: Mídias e Comunicação, Comunicação inclusiva,Técnicas de negociação, entrevista e condução de reuniões. Cidadania e dimensões do trabalho: Ética profissional, Inclusão no mundo profissional, Legislação e aspectos coletivos (sindicatos, regulamentação da profissão, comitê de ética).',
    difficultyLevel: '1/5',
    evaluationStyle: 'Apresentações, trabalhos',
    teachers: 'Adriana Vivacqua',
    advice: 'Ótima matéria!',
    availability: 'Alta',
    schedule: 'Qui 10h-12h (Turma A) / Qui 13h-15h (Turma B)',
  },
  {
    id: 'MAE111',
    name: 'Cálculo Infinitesimal I',
    shortName: 'Calc I',
    preRequisites: [],
    postRequisites: ['ICP238', 'MAE992', 'FIT122'],
    credits: 6.0,
    curriculum: 'Funções de uma variável real. Limites e derivadas. Cálculo de derivadas e aplicações. Teorema do valor médio. Integral definida. Teorema fundamental do cálculo. Cálculo de integrais e aplicações.',
    difficultyLevel: '5/5',
    evaluationStyle: 'Provas',
    teachers: 'Vários',
    advice: 'Inferno 1.0. Estuda até dizer chega. Se passar de primeira, será um dos poucos.',
    availability: 'Baixa',
    schedule: '',
  },
  {
    id: 'ICP115',
    name: 'Álgebra Linear Algorítmica',
    shortName: 'ALA',
    preRequisites: ['ICP136', 'ICP144'],
    postRequisites: ['ICP248', 'ICP350', 'ICP251', 'ICP365', 'ICP013', 'ICP027', 'ICP638', 'ICP639', 'MAE994'],
    credits: 5.0,
    curriculum: 'Vetores no plano, base e combinação linear. Transformações lineares e matrizes no plano. Autovalores e autovetores para operadores do plano. Diagonalização e mudança de variáveis em dimensão dois. Sistemas lineares e eliminação gaussiana. Rn e seus subespaços. Interseção, soma e complemento de subespaços. Dependência e independência linear. Base e coordenadas. Transformações lineares e matrizes. Mudança de base. Autovalores e autovetores e diagonalização de operadores.',
    difficultyLevel: '5/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Juliana Valério',
    advice: 'Estude e faça exercício, repetition is key.',
    availability: 'Alta',
    schedule: 'Seg-Qua 13h-15h e Sex 10h-12h',
  },
  {
    id: 'ICP116',
    name: 'Estrutura dos Dados',
    shortName: 'ED',
    preRequisites: ['ICP141'],
    postRequisites: ['ICP489', 'ICP368', 'ICP035', 'ICP036', 'ICP356', 'ICP471', 'ICP605'],
    credits: 4.0,
    curriculum: 'Complexidade de algoritmos. Listas lineares em alocação sequencial e dinâmica. Árvores, Árvores Binárias de Busca e Árvores balanceadas, heap. Tabelas de dispersão (hash tables). Conjuntos, coleção de conjuntos disjuntos. Listas de Prioridades. Algoritmos de ordenação: Radix sort, quick e heap sort.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Claudson Bornstein',
    advice: 'Essencial, vale a pena ir bem nessa daqui, conta legal pra currículo.',
    availability: 'Média',
    schedule: 'Ter-Qui 13h-15h (Turma A) / Ter-Qui 10h-12h (Turma B)',
  },
  {
    id: 'ICP237',
    name: 'Introd à Modelagem de Sistemas',
    shortName: 'IMS',
    preRequisites: ['ICP132', 'ICP141'],
    postRequisites: ['ICP009', 'ICP020', 'ICP023', 'ICP024', 'ICP041', 'ICP042', 'ICP051', 'ICP052', 'ICP616', 'ICP640'],
    credits: 4.0,
    curriculum: 'Introdução à modelagem de sistemas (por que e o que modelar de sistemas computacionais); Modelagem de Sistemas usando notação atual (ex: UML): Caso Uso; Diagramas de Atividade; Diagrama de Classes (conceitual); Modelagem de Dados.',
    difficultyLevel: '2/5',
    evaluationStyle: 'Trabalhos',
    teachers: 'Rafael Maiani',
    advice: 'Se for com a França aproveite, ótima professora. Rafael e Eldanae são bem rígidos em relação a presença.',
    availability: 'Alta',
    schedule: 'Ter-Qui 15h-17h',
  },
  {
    id: 'ICP238',
    name: 'Introd à Computação Numérica',
    shortName: 'ICN',
    preRequisites: ['ICP131', 'ICP133', 'MAE111'],
    postRequisites: ['ICP248', 'ICP365'],
    credits: 2.0,
    curriculum: 'Noções sobre erros e representação de ponto flutuante. Número de condicionamento e sensibilidade dos métodos numéricos. Diferenciação numérica e Polinômio de Taylor. Cálculo de zeros de funções. Interpolação polinomial: formas de Lagrange e de Newton. Integração numérica. Métodos numéricos para equações diferenciais ordinárias.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Marcello Goulart',
    advice: 'Antigo Cálculo Numérico, é bom ter aprendido os outros cálculos.',
    availability: 'Média',
    schedule: 'Qua 15h-17h',
  },
  {
    id: 'ICP239',
    name: 'Programação Orientada a Objeto',
    shortName: 'POO',
    preRequisites: ['ICP141'],
    postRequisites: ['ICP361', 'ICP061', 'ICP062', 'ICP081', 'ICP082', 'ICP083', 'ICP084', 'ICP085'],
    credits: 4.0,
    curriculum: 'Classes e objetos; Atributos e métodos; Encapsulamento; Herança e polimorfismo; Agregação e composição; Métodos abstratos e classes abstratas; Interfaces; Tipos genéricos; Tipos enumeráveis; Padrões de projeto: singleton, factory, observer (orientação a eventos); Testes unitários; Escrita e depuração de programas usando IDEs modernas; Listas, Mapas, Conjuntos; Tratamento de exceções.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Ronald Chiesse',
    advice: 'Outra matéria essencial, estude bastante, a média costuma ser 5 com o Mitre.',
    availability: 'Média',
    schedule: 'Ter-Qui 10h-12h',
  },
  {
    id: 'MAE992',
    name: 'Cálculo Integ e Diferencial II',
    shortName: 'Calc II',
    preRequisites: ['MAE111'],
    postRequisites: ['ICP248', 'ICP351', 'FIM230', 'ICP013', 'MAE993', 'MAE994'],
    credits: 4.0,
    curriculum: 'Curvas no plano e no espaço, velocidade e aceleração. Funções de duas e mais variáveis, derivadas direcionais. Derivadas parciais e derivada como aproximação linear. Funções implícitas, multiplicadores de lagrange. Hessiana. Equações diferenciais ordinárias de primeira ordem e equações diferenciais ordinárias de segunda ordem com coeficientes constantes.',
    difficultyLevel: '5/5',
    evaluationStyle: 'Provas',
    teachers: 'Vários',
    advice: 'Inferno 2.0. Escolha um professor bom para assistir as aulas. Talvez o Responde Aí te ajude. Maioria das pessoas já fez mais de uma vez',
    availability: 'Baixa',
    schedule: '',
  },
  {
    id: 'ICP246',
    name: 'Arquitet Comput e Sist Operac',
    shortName: 'Arq Comp SO',
    preRequisites: ['ICP133', 'ICP141'],
    postRequisites: ['ICP353', 'ICP006', 'ICP025', 'ICP028'],
    credits: 4.0,
    curriculum: 'Organização interna e arquiteturas de computadores. Conjunto de instruções. Modos de endereçamento. Linguagem de máquina. Interrupções e exceções. Barramentos, comunicações, interfaces, periféricos. Gerência de operações de entrada/saída. Processadores superescalares e superpipeline e arquiteturas multiprocessadores. Organização da memória, coerência e consistência de cache, memória virtual. Gerência de tarefas e de memória. Sistemas de armazenamento e de arquivos.',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Gabriel Pereira',
    advice: 'Muita matéria para pouco tempo. A prova da Rafaela é bem condizente, preste atenção na revisão dela.',
    availability: 'Alta',
    schedule: 'Ter-Qui 10h-12h',
  },
  {
    id: 'ICP248',
    name: 'Comput Científ e Análise Dados',
    shortName: 'CO CA DA',
    preRequisites: ['ICP115', 'ICP238', 'MAE992'],
    postRequisites: ['ICP363', 'ICP014', 'ICP019'],
    credits: 4.0,
    curriculum: 'Sistemas lineares: Modelagem de sistemas lineares, Métodos diretos: Fatoração LU e QR., Métodos iterativos: Gauss-Jacobi; Gauss-Seidel. Ajuste de curvas: Modelagem; Método dos Mínimos quadrados; Curvas Spline. SVD e autovalores: Modelagem: Sistema lineares dinâmicos; Métodos iterativos: Método da potência; Algoritmo QR.; Aplicações: Redução de dimensão; Pseudoinversa. Sistemas não lineares: Modelagem de sistemas não lineares; Método de Newton; Método do gradiente descendente.',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'João Paixão',
    advice: 'Listas, trabalhos e provas bem longas estilo João Paixão.',
    availability: 'Baixa',
    schedule: 'Qua-Sex 10h-12h',
  },
  {
    id: 'ICP249',
    name: 'Tecnologia e Sociedade',
    shortName: 'Tec Soc',
    preRequisites: ['ICP145'],
    postRequisites: ['ICP472'],
    credits: 4.0,
    curriculum: 'Idade média: surgimento das primeiras universidades. Idade moderna: a característica universal de Leibniz, redes sociais acadêmicas no século XVII, Euler e a teoria de grafos. Revolução industrial: Boole, de Morgan e a lógica simbólica, Babbage, Ada Lovelace e a máquina analítica, algoritmos eficientes e computação humana. Século XX: Turing e o computador universal, von Neumann e os primeiros computadores eletrônicos, Julia Robinson e a impossibilidade da solução de equações diofantinas. Século XXI: internet e outros temas atuais.',
    difficultyLevel: '1/5',
    evaluationStyle: 'Trabalhos, Apresentações',
    teachers: 'Jonice De Oliveira',
    advice: 'Se for a Jonice comemore. Com a Marilu, relatos dizem que é bem trabalhoso, mas nada muito complicado.',
    availability: 'Baixa',
    schedule: 'Ter-Qui 13h-15h',
  },
  {
    id: 'ICP489',
    name: 'Banco de Dados I',
    shortName: 'BD',
    preRequisites: ['ICP116'],
    postRequisites: ['ICP010', 'ICP011', 'ICP012', 'ICP021', 'ICP022', 'ICP030', 'ICP012', 'ICP357', 'ICP491', 'ICP532'],
    credits: 4.0,
    curriculum: 'Introdução a Sistemas de Banco de Dados; Projeto de Banco de Dados; Modelo de Dados Relacional; Consultas em Dados Relacionais; Recursos Avançados em SQL.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Provas, trabalhos, apresentações',
    teachers: 'Vivian Dos Santos',
    advice: 'Se garanta na P1. Álgebra relacional is no joke.',
    availability: 'Alta',
    schedule: 'Qua-Sex 8h-10h',
  },
  {
    id: 'MAD243',
    name: 'Estatística e Probabilidade',
    shortName: 'Prob Est',
    preRequisites: ['MAE992'],
    postRequisites: ['ICP350', 'ICP362', 'ICP363', 'ICP103', 'ICP359', 'ICP532'],
    credits: 4.0,
    curriculum: 'Noções básicas de Estatística e Probabilidade. Análise exploratória. Variáveis aleatórias e Distribuições de Probabilidades. Distribuições conjuntas marginais e condicionais. Valores esperados. Teoremas limites. Teorema central do limite. Distribuições amostrais. Estimação de parâmetros. Testes de Hipóteses.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Hugo Tremonte',
    advice: 'Matéria essencial pra AD. Estude bastante, ambos os professores que atualmente dão são tranquilos. Caso tenha muita dificuldade, o Responde Aí é uma das melhores fontes de estudo, basicamente segue o formato do conteúdo dado em sala.',
    availability: 'Alta',
    schedule: 'Ter-Qui 8h-10h',
  },
  {
    id: 'ICP123',
    name: 'Linguagens Formais',
    shortName: 'LF',
    preRequisites: ['ICP141', 'ICP144'],
    postRequisites: ['ICP370', 'ICP471'],
    credits: 4.0,
    curriculum: 'Hierarquia de Chomsky. Linguagens e gramáticas (regulares, livres de contexto, sensíveis ao contexto). Máquinas de estados finitos (modelos não determinísticos, expressões regulares, minimização). Autômato de pilha. Algoritmos e ferramentas de análise léxica e sintática (LL(k) e LR(k)).',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Hugo Musso',
    advice: 'Matéria abstrata, pré-lógica. Estude e reze para não ser o Mitre. Apostila do Menasché é uma boa.',
    availability: 'Baixa',
    schedule: 'Seg-Qua 13h-15h',
  },
  {
    id: 'ICP350',
    name: 'Modelagem e Aval de Desempenho',
    shortName: 'AD',
    preRequisites: ['ICP115', 'MAD243'],
    postRequisites: [],
    credits: 4.0,
    curriculum: 'Introdução às técnicas de aferição e modelagem analítica. Técnicas para a construção de simuladores e análise de resultados com uso de intervalos de confiança. Uso de cadeias de Markov de tempo discreto e de tempo contínuo para a modelagem e resolução de diferentes problemas envolvendo a análise em equilíbrio e em transiente. Aplicação da teoria de filas M/G/1 e análise de suas variações. Filas com prioridade e aplicações práticas.',
    difficultyLevel: '5/5',
    evaluationStyle: 'Provas, trabalhos, listas, apresentações',
    teachers: 'Vinícius Gusmão',
    advice: 'Provavelmente a matéria mais díficil do curso inteiro. Conteúdo complicado, listas longas, provas maiores ainda. Faça todos os exercícios, pergunte em sala, demonstre interesse. Ela foi o fim de muitos alunos do curso.',
    availability: 'Alta',
    schedule: 'Seg-Qua 10h-12h',
  },
  {
    id: 'ICP351',
    name: 'Model Matemát e Computacional',
    shortName: 'Mod Mat',
    preRequisites: ['ICP115', 'MAE992'],
    postRequisites: ['ICP014', 'ICP031', 'ICP032'],
    credits: 4.0,
    curriculum: 'Etapas do processo de modelagem. Modelos científicos e definição de modelo matemático. Classificação dos modelos de interesse. Apresentação de exemplos dos vários tipos de modelos. Modelagem de problemas de diferentes áreas do conhecimento, como física, biologia, etc., baseados em sistemas de equações de diferenças e diferenciais, otimização, grafos e cadeias de Markov. Outros tópicos de interesse a critério do professor.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Trabalhos, listas',
    teachers: 'Severino Collier',
    advice: 'Se for o Marcello, aproveite. Se for o Amaury, corra.',
    availability: 'Baixa',
    schedule: 'Seg-Qua 8h-10h',
  },
  {
    id: 'ICP353',
    name: 'Computadores e Programação',
    shortName: 'Comp Prog',
    preRequisites: ['ICP246'],
    postRequisites: ['ICP361', 'ICP473', 'ICP353'],
    credits: 4.0,
    curriculum: 'Tradução de linguagem de alto nível para linguagem de montagem; Compilação com otimização e análise de desempenho; Comparativo entre as arquiteturas de 32 e 64 bits; Comunicação entre processos, chamadas de sistemas, tratadores de eventos; Ligação de programas e criação de bibliotecas estáticas e compartilhadas; Otimização de desempenho de programas frente a novas arquiteturas de processadores e limitações dos compiladores.',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Valéria Menezes',
    advice: 'Outra matéria de arquitetura, bem baixo nível. Estude e tire bastante dúvida, traduzir coisas de assembly nunca são fáceis.',
    availability: 'Média',
    schedule: 'Ter-Qui 8h-10h',
  },
  {
    id: 'ICP368',
    name: 'Algoritmos e Grafos',
    shortName: 'Alg Graf',
    preRequisites: ['ICP116', 'ICP144'],
    postRequisites: ['ICP508', 'ICP518', 'ICP606', 'ICP633', 'ICP636'],
    credits: 4.0,
    curriculum: 'Representação de Grafos; Ordenação Topológica; Buscas em grafos e Digrafos (largura e profundidade); Técnicas de Desenvolvimento de Algoritmos; Decomposição; Recursão; Algoritmo Guloso; Programação Dinâmica; Aplicação das Técnicas Usadas; Fluxo Máximo.',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas',
    teachers: 'Mitre Costa',
    advice: '',
    availability: 'Baixa',
    schedule: 'Ter-Qui 10h-12h',
  },
  {
    id: 'ICP361',
    name: 'Programação Concorrente',
    shortName: 'Comp Conc',
    preRequisites: ['ICP239', 'ICP353'],
    postRequisites: ['ICP071', 'ICP367', 'ICP622'],
    credits: 4.0,
    curriculum: 'Técnicas de programação concorrente: multiprocessos, multithreading. Comunicação via variáveis compartilhadas e troca de mensagens. Sincronização por exclusão mútua e condicional e métodos de trava: locks, semáforos, variáveis de condição. Problemas clássicos da concorrência. Deadlock, starvation, thread safety. Programação assíncrona: futuros, promessas, async/await. Modelagem, teste e avaliação de programas concorrentes. Ambientes de programação concorrente.',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas, trabalhos',
    teachers: 'Silvana Rosetto',
    advice: 'Matéria relativamente complicada, porém a didática da Silvana é excelente. Contudo, a mão dela é bem pesada então estude bastante.',
    availability: 'Baixa',
    schedule: 'Ter-Qui 8h-10h',
  },
  {
    id: 'ICP362',
    name: 'Redes de Computadores I',
    shortName: 'Redes',
    preRequisites: ['ICP131', 'ICP133', 'MAD243'],
    postRequisites: ['ICP473', 'ICP006', 'ICP025', 'ICP026', 'ICP072', 'ICP367'],
    credits: 4.0,
    curriculum: 'Motivação e apresentação geral do estudo sobre redes de computadores; Arquitetura de redes; Princípios de comunicação e nível físico; Tecnologias de acesso; Congestionamento em redes; A Internet e seus protocolos de aplicação, de transporte, de roteamento, e de enlace; Acesso múltiplo a meio de transmissão; Tecnologia Ethernet e suas variações; MPLS (Multiprotocol Label Switching) e engenharia de tráfego; Comunicação sem fio e mobilidade IP (Internet Protocol).',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas, trabalhos, listas, apresentações',
    teachers: 'Daniel Sadoc',
    advice: 'Se for com o Sadoc é uma matéria 5/5. Muito conteúdista e densa, estudar nunca vai ser o suficiente. Caso a Carol esteja lecionando aproveite para passar.',
    availability: 'Alta',
    schedule: 'Seg-Qua 10h-12h',
  },
  {
    id: 'ICP363',
    name: 'Introd Aprendizado de Máquina',
    shortName: 'ML',
    preRequisites: ['ICP248', 'MAD243'],
    postRequisites: ['ICP011', 'ICP012'],
    credits: 4.0,
    curriculum: 'Contextualizando o aprendizado de máquina (história e paradigmas); Questões éticas; Tipos de aprendizado de máquina: supervisionado, não supervisionado, por reforço; Métricas de avaliação; Tipos de problemas; Métodos de aprendizado: classificação (árvore de decisão, regressão linear, regressão logística, classificador Bayesiano, redes neurais, SVM), agrupamento (K-means, classificação hierárquico), associação (algoritmos a priori); Aprendizado por reforço; Programação em lógica indutiva.',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas, trabalhos, listas',
    teachers: 'João Carlos',
    advice: 'Matéria densa, mas trabalhos relativamente tranquilos, cuidado com a prova',
    availability: 'Baixa',
    schedule: 'Ter-Qui 13h-15h',
  },
  {
    id: 'ICP365',
    name: 'Otimização',
    shortName: 'Otim',
    preRequisites: ['ICP115', 'ICP238'],
    postRequisites: ['ICP017', 'ICP018', 'ICP031', 'ICP032'],
    credits: 4.0,
    curriculum: 'Modelagem e Caracterização dos Problemas. Programação Linear. Programação Linear Inteira. Programação Não Linear Irrestrita. Aplicações.',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas, trabalhos, listas, apresentações',
    teachers: 'Maria Helena, Luziane',
    advice: 'Matemática densa, faça muitos exercícios, a Maria Helena é bem compreensível.',
    availability: 'Baixa',
    schedule: '',
  },
  {
    id: 'ICP370',
    name: 'Lógica e Computabilidade',
    shortName: 'Log',
    preRequisites: ['ICP123'],
    postRequisites: [],
    credits: 4.0,
    curriculum: 'Linguagens e sintaxe da Lógica de Primeira Ordem (LPO). Formalização e modelagem de problemas usando LPO. Semântica da LPO. Sistemas de prova para a LPO. Noções da equivalência entre consequência semântica e sintática. Noções de provadores automáticos. O Problema da Decisão de Hilbert-Ackermann. Máquina de Turing. Programação em Máquinas de Turing. Máquina de Turing universal. Problema da Parada. Reduções entre problemas; problemas indecidíveis. Noções da equivalência entre Máquinas de Turing e outros modelos de computação.',
    difficultyLevel: '4/5',
    evaluationStyle: 'Provas, listas',
    teachers: 'Hugo Nobrega',
    advice: 'Matéria muito densa e abstrata, mesmo se você estudar e achar que está entendendo, na verdade não está. Sempre double-check com o prof, conte com a compaixão do Hugo.',
    availability: 'Baixa',
    schedule: 'Qua-Sex 8h-10h',
  },
  {
    id: 'ICP472',
    name: 'Metodologia da Pesquisa',
    shortName: 'Met Pesq',
    preRequisites: ['ICP249'],
    postRequisites: [],
    credits: 4.0,
    curriculum: 'Concepções do conhecimento e da pesquisa acadêmica. Tipos de pesquisa. Processo de desenvolvimento da pesquisa. Estruturação, redação e formatação de projeto de pesquisa. Relevância e contextualização da pesquisa. Fundamentação e contextualização da pesquisa. Estratégias de embasamento. Levantamento de fontes e referências. Ética na redação científica e legitimidade do saber. Métodos e estratégias de pesquisa. Coleta de dados. Técnicas para análise de dados. Planejamento e cronograma.',
    difficultyLevel: '2/5',
    evaluationStyle: 'Apresentações, trabalhos',
    teachers: 'Carla Amor',
    advice: 'Matéria tranquila, talvez tenha uma quantidade de trabalho um pouco desproporcional, por isso é recomendável puxar com algumas eletivas.',
    availability: 'Baixa',
    schedule: 'Seg-Qua 8h-10h',
  },
  {
    id: 'ICP473',
    name: 'Segurança da Informação',
    shortName: 'Seg Info',
    preRequisites: ['ICP353', 'ICP362'],
    postRequisites: [],
    credits: 4.0,
    curriculum: 'Fundamentos e princípios de segurança em sistemas computacionais; Leis, normas, políticas e padrões de segurança da informação; Elementos do processo de segurança da informação; Segurança em redes e em infraestrutura; Tipos de ataque; Ferramentas e políticas de segurança em redes; Segurança na Web; Segurança de software; Técnicas básicas e modernas de encriptação; Assinatura e certificado digital; Segurança de dados e criptografia; Segurança da informação e sociedade.',
    difficultyLevel: '3/5',
    evaluationStyle: 'Apresentações, prova',
    teachers: 'Evandro',
    advice: 'Pouco se sabe sobre essa matéria, porém parece ser tranquila.',
    availability: 'Baixa',
    schedule: '',
  },
  {
    id: 'ICPK01',
    name: 'Trabalho de Conclusão do Curso',
    shortName: 'TCC',
    preRequisites: ['ICP472'],
    postRequisites: [],
    credits: 2.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE1',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 1',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE2',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 2',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE3',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 3',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE4',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 4',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE5',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 5',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE6',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 6',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE7',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 7',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE8',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 8',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE9',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 9',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE10',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 10',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
  {
    id: 'ELE11',
    name: 'Escolha uma eletiva',
    shortName: 'ELE 11',
    preRequisites: [],
    postRequisites: [],
    credits: 0.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: '',
  },
];

export const semesters = [
  ['ICP131', 'ICP132', 'ICP133', 'ICP134', 'ICP135', 'ICP136'],
  ['ICP141', 'ICP142', 'ICP143', 'ICP144', 'ICP145', 'MAE111'],
  ['ICP115', 'ICP116', 'ICP237', 'ICP238', 'ICP239', 'MAE992'],
  ['ICP246', 'ICP248', 'ICP249', 'ICP489', 'MAD243'],
  ['ICP123', 'ICP350', 'ICP351', 'ICP353', 'ICP368'],
  ['ICP361', 'ICP362', 'ICP363', 'ICP365', 'ICP370'],
  ['ICP472', 'ICP473', 'ELE1', 'ELE2', 'ELE3'],
  ['ICPK01', 'ELE4', 'ELE5', 'ELE6', 'ELE7'],
  ['ELE8', 'ELE9', 'ELE10', 'ELE11'],
]

export const humanities: SubjectType[] = [
  {
    id: 'FCF108',
    name: 'Ética I',
    shortName: 'Ética I',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'FCF614',
    name: 'Ética II',
    shortName: 'Ética II',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'FCF615',
    name: 'Ética III',
    shortName: 'Ética III',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'FCF616',
    name: 'Ética IV',
    shortName: 'Ética IV',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP101',
    name: 'Teoria Direitos Fundamentais',
    shortName: 'Dir Fund',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP110',
    name: 'Fund Direitos Humanos',
    shortName: 'Fund Dir Hum',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP120',
    name: 'Fund Polít Públicas Dir Hum',
    shortName: 'Pol Pub Dir Hum',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP130',
    name: 'Tóp Esp Polít Públ Dir Hum I',
    shortName: 'Top Esp Pol Pub I',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP140',
    name: 'Tóp Esp Polít Públ Dir Hum II',
    shortName: 'Top Esp Pol Pub II',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP141',
    name: 'Tóp Esp Polít Públ Dir Hum III',
    shortName: 'Top Esp Pol Pub III',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP142',
    name: 'Tóp Esp Polít Públ Dir Hum IV',
    shortName: 'Top Esp Pol Pub IV',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP143',
    name: 'Tóp Esp Polít Públ Dir Hum V',
    shortName: 'Top Esp Pol Pub V',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP144',
    name: 'Tóp Esp Polít Públ Dir Hum VI',
    shortName: 'Top Esp Pol Pub VI',
    preRequisites: [],
    postRequisites: [],
    credits: 2.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP145',
    name: 'Tóp Esp Polít Públ Dir Hum VII',
    shortName: 'Top Esp Pol Pub VII',
    preRequisites: [],
    postRequisites: [],
    credits: 2.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP146',
    name: 'Dir Hum, Gênero e Sexualidades',
    shortName: 'Dir Hum Gen Sex',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP147',
    name: 'Dir Hum e Democracia',
    shortName: 'Dir Hum Dem',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP148',
    name: 'Dir Hum, Pens Negro e Racismo',
    shortName: 'Dir Hum Pens Neg Rac',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP149',
    name: 'Dir Hum e Meio Ambiente',
    shortName: 'Dir Hum Meio Amb',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP150',
    name: 'Dir Hum e Saúde',
    shortName: 'Dir Hum Saúde',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP151',
    name: 'Dir Hum e Cultura',
    shortName: 'Dir Hum Cult',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP152',
    name: 'Dir Hum, Conflit e Territórios',
    shortName: 'Dir Hum Con Ter',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP153',
    name: 'Dir Hum e Trabalho',
    shortName: 'Dir Hum Trab',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP154',
    name: 'Dir Hum e Sistema de Justiça',
    shortName: 'Dir Hum Sis Jus',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP155',
    name: 'Dir Hum e Movimentos Sociais',
    shortName: 'Dir Hum Mov Soc',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP156',
    name: 'Dir Hum, Globalização e Tecnol',
    shortName: 'Dir Hum Glob Tec',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP157',
    name: 'Dir Hum, Violência e Democrac',
    shortName: 'Dir Hum Vio Dem',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP158',
    name: 'Dir Hum e Polít Internacional',
    shortName: 'Dir Hum Pol Int',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP159',
    name: 'Dir Hum e Desigualdade Sociais',
    shortName: 'Dir Hum Des Soc',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'NEP160',
    name: 'Dir Hum na América Latina',
    shortName: 'Dir Hum Am Lat',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
]

export const electives: SubjectType[] = [
  {
    id: 'FIT112',
    name: 'Física I',
    shortName: 'Fis I',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'FIT122',
    name: 'Física II',
    shortName: 'Fis II',
    preRequisites: [
      'FIT112',
      'MAE111'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'FIM230',
    name: 'Física III',
    shortName: 'Fis III',
    preRequisites: [
      'FIT112',
      'MAE992'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'FIM240',
    name: 'Física IV',
    shortName: 'Fis IV',
    preRequisites: [
      'FIM230'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP005',
    name: 'Ética em Computação',
    shortName: 'Et Comp',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP006',
    name: 'Internet das Coisas',
    shortName: 'IOT',
    preRequisites: [
      'ICP246',
      'ICP362'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP009',
    name: 'Sist Colaborat e Comput Social',
    shortName: 'Sis Col',
    preRequisites: [
      'ICP237'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP010',
    name: 'Web Semântica',
    shortName: 'Web Sem',
    preRequisites: [
      'ICP489'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP011',
    name: 'Tóp Esp em Ciência de Dados I',
    shortName: 'Cie Dados I',
    preRequisites: [
      'ICP363',
      'ICP489'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP012',
    name: 'Tóp Esp em Ciência de Dados II',
    shortName: 'Cie Dados II',
    preRequisites: [
      'ICP363',
      'ICP489'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP013',
    name: 'Séries e Transformadas Comput',
    shortName: 'Transformadas',
    preRequisites: [
      'ICP115',
      'MAE992'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP014',
    name: 'Comput Científ Equaç Dif Ordin',
    shortName: 'Eq Dif Ord',
    preRequisites: [
      'ICP248',
      'ICP351'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP015',
    name: 'Comput Científ Equaç Dif Parc',
    shortName: 'Eq Dif Parc',
    preRequisites: [
      'ICP014'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP016',
    name: 'Introd Métod Elementos Finitos',
    shortName: 'Ele Fin',
    preRequisites: [
      'ICP248'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP017',
    name: 'Otimização Linear',
    shortName: 'Otim Lin',
    preRequisites: [
      'ICP365'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP018',
    name: 'Otimização Não Linear',
    shortName: 'Otim N Lin',
    preRequisites: [
      'ICP365'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP019',
    name: 'Álgebra Linear Aplicada',
    shortName: 'AL Aplicada',
    preRequisites: [
      'ICP248'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP020',
    name: 'Engenharia de Software',
    shortName: 'Eng Soft',
    preRequisites: [
      'ICP237'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP021',
    name: 'Tóp Esp em Engenharia Dados I',
    shortName: 'Eng Dados I',
    preRequisites: [
      'ICP489'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP022',
    name: 'Tóp Esp em Engenharia Dados II',
    shortName: 'Eng Dados II',
    preRequisites: [
      'ICP489'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP023',
    name: 'Gestão de Projetos',
    shortName: 'Gestao Proj',
    preRequisites: [
      'ICP237'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP024',
    name: 'Análise e Projeto de Sistemas',
    shortName: 'Proj Sis',
    preRequisites: [
      'ICP237'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP025',
    name: 'Computação em Nuvem',
    shortName: 'Comp Nuvem',
    preRequisites: [
      'ICP246',
      'ICP362'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP026',
    name: 'Redes de Computadores II',
    shortName: 'Redes II',
    preRequisites: [
      'ICP362'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP027',
    name: 'Criptografia',
    shortName: 'Cripto',
    preRequisites: [
      'ICP115',
      'ICP131',
      'ICP134'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP028',
    name: 'Tóp Esp em Arquitetura Comput',
    shortName: 'Top Esp Arq Comp',
    preRequisites: [
      'ICP246'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP029',
    name: 'Empreendedorismo e Inovação',
    shortName: 'Empreend',
    preRequisites: [
      'ICP145'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP030',
    name: 'Governança e Gestão de Dados',
    shortName: 'Gestão Dados',
    preRequisites: [
      'ICP489'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP031',
    name: 'Tóp Esp em Comp Científica I',
    shortName: 'Comp Ci I',
    preRequisites: [
      'ICP351',
      'ICP365'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP032',
    name: 'Tóp Esp em Comp Científica II',
    shortName: 'Comp Ci II',
    preRequisites: [
      'ICP351',
      'ICP365'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP034',
    name: 'Análise de Redes Sociais',
    shortName: 'Redes Socias',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP035',
    name: 'Tóp Esp em Teoria da Comput I',
    shortName: 'Teo Comp I',
    preRequisites: [
      'ICP116',
      'ICP144'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP036',
    name: 'Tóp Esp em Teoria da Comput II',
    shortName: 'Teo Comp II',
    preRequisites: [
      'ICP116',
      'ICP144'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP038',
    name: 'Fundamentos Processo Negócio',
    shortName: 'Proc Neg',
    preRequisites: [
      'ICP132'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP041',
    name: 'Oficina de Desenv Software I',
    shortName: 'Dev Soft I',
    preRequisites: [
      'ICP237'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP042',
    name: 'Oficina de Desenv Software II',
    shortName: 'Dev Soft II',
    preRequisites: [
      'ICP237'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP051',
    name: 'Tóp Esp em Eng de Software I',
    shortName: 'Eng Soft I',
    preRequisites: [
      'ICP237'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP052',
    name: 'Tóp Esp em Eng de Software II',
    shortName: 'Eng Soft II',
    preRequisites: [
      'ICP237'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP061',
    name: 'Desenvolvimento Web I',
    shortName: 'Web I',
    preRequisites: [
      'ICP239'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP062',
    name: 'Desenvolvimento Web II',
    shortName: 'Web II',
    preRequisites: [
      'ICP239'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP071',
    name: 'Tóp Esp em Sist Computacion I',
    shortName: 'Ofi Tec I',
    preRequisites: [
      'ICP361'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP072',
    name: 'Tóp Esp em Sist Computacion II',
    shortName: 'Ofi Tec II',
    preRequisites: [
      'ICP362'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP081',
    name: 'Oficina de Teconologia I',
    shortName: 'Ofi Tec I',
    preRequisites: [
      'ICP141',
      'ICP239'
    ],
    postRequisites: [],
    credits: 2.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP082',
    name: 'Oficina de Teconologia II',
    shortName: 'Ofi Tec II',
    preRequisites: [
      'ICP141',
      'ICP239'
    ],
    postRequisites: [],
    credits: 2.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP083',
    name: 'Oficina de Teconologia III',
    shortName: 'Ofi Tec III',
    preRequisites: [
      'ICP141',
      'ICP239'
    ],
    postRequisites: [],
    credits: 2.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP084',
    name: 'Oficina de Teconologia IV',
    shortName: 'Ofi Tec IV',
    preRequisites: [
      'ICP141',
      'ICP239'
    ],
    postRequisites: [],
    credits: 2.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP085',
    name: 'Oficina de Teconologia V',
    shortName: 'Ofi Tec V',
    preRequisites: [
      'ICP141',
      'ICP239'
    ],
    postRequisites: [],
    credits: 2.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP091',
    name: 'Tóp Esp em Ciência Comput I',
    shortName: 'Top Ci Comp I',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP092',
    name: 'Tóp Esp em Ciência Comput II',
    shortName: 'Top Ci Comp II',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP093',
    name: 'Tóp Esp em Ciência Comput III',
    shortName: 'Top Ci Comp III',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP094',
    name: 'Tóp Esp em Ciência Comput IV',
    shortName: 'Top Ci Comp IV',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP095',
    name: 'Tóp Esp em Ciência Comput V',
    shortName: 'Top Ci Comp V',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP096',
    name: 'Lab Análise de Redes Sociais',
    shortName: 'Redes Sociais II',
    preRequisites: [
      'ICP034'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP100',
    name: 'Introd Gestão Estratégica Ti',
    shortName: 'IGETi',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP102',
    name: 'Tecn para Grandes Vol de Dados',
    shortName: 'GVD',
    preRequisites: [
      'ICP489'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP103',
    name: 'Análise de Risco',
    shortName: 'Anal Risco',
    preRequisites: [
      'MAD243'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP356',
    name: 'Organização de Dados II',
    shortName: 'Org Dados II',
    preRequisites: [
      'ICP116'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP357',
    name: 'Data Warehousing e Intel Negóc',
    shortName: 'DW',
    preRequisites: [
      'ICP489'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP359',
    name: 'Introd ao Suporte à Decisão',
    shortName: 'Sup Dec',
    preRequisites: [
      'MAD243'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP367',
    name: 'Sistemas Distribuídos',
    shortName: 'Sis Dis',
    preRequisites: [
      'ICP361',
      'ICP362'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP465',
    name: 'Tóp Esp Informática Sociedade',
    shortName: 'Info Soc',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP471',
    name: 'Compiladores',
    shortName: 'Compiladores',
    preRequisites: [
      'ICP116',
      'ICP123',
      'ICP353'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP478',
    name: 'Métodos Numéricos I',
    shortName: 'Met Num I',
    preRequisites: [
      'ICP231'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP491',
    name: 'Banco de Dados II',
    shortName: 'BD II',
    preRequisites: [
      'ICP489'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP508',
    name: 'Inteligência Artificial',
    shortName: 'IA',
    preRequisites: [
      'ICP368'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP518',
    name: 'Teoria de Grafos',
    shortName: 'Grafos',
    preRequisites: [
      'ICP368'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP532',
    name: 'Mineração de Dados',
    shortName: 'Min Dados',
    preRequisites: [
      'ICP489',
      'MAD243'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP603',
    name: 'Gestão do Conhecimento',
    shortName: 'Gest Con',
    preRequisites: [
      'ICP142'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP605',
    name: 'Recuperação de Informação',
    shortName: 'Rec Info',
    preRequisites: [
      'ICP116'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP606',
    name: 'Tóp Esp em Programação',
    shortName: 'TEP',
    preRequisites: [
      'ICP368'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP616',
    name: 'Interação Humano-computador',
    shortName: 'IHC',
    preRequisites: [
      'ICP237'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP622',
    name: 'Program Paralela e Distribuída',
    shortName: 'Prog Paral',
    preRequisites: [
      'ICP361'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP633',
    name: 'Algoritmos de Aproximação',
    shortName: 'Alg Aprox',
    preRequisites: [
      'ICP368'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP636',
    name: 'Algoritmos Paralelos',
    shortName: 'Alg Paral',
    preRequisites: [
      'ICP368'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP638',
    name: 'Computação Algébrica',
    shortName: 'Comp Alg',
    preRequisites: [
      'ICP115',
      'ICP131',
      'ICP134'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP639',
    name: 'Computação Quântica',
    shortName: 'Comp Quant',
    preRequisites: [
      'ICP115',
      'ICP134'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICP640',
    name: 'Projeto Teste de Software',
    shortName: 'Proj Test',
    preRequisites: [
      'ICP237'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICPX03',
    name: 'Monitoria I',
    shortName: 'Monit I',
    preRequisites: [],
    postRequisites: [],
    credits: 2.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'ICPX04',
    name: 'Monitoria II',
    shortName: 'Monit II',
    preRequisites: [
      'ICPX03'
    ],
    postRequisites: [],
    credits: 2.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'IEE115',
    name: 'Economia',
    shortName: 'Econ',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'LEB599',
    name: 'Est da Líng Bras de Sinais I',
    shortName: 'Libras',
    preRequisites: [],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'MAE993',
    name: 'Cálculo Int e Diferencial III',
    shortName: 'Calc III',
    preRequisites: [
      'MAE992'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  },
  {
    id: 'MAE994',
    name: 'Cálculo Int e Diferencial IV',
    shortName: 'Calc IV',
    preRequisites: [
      'ICP115',
      'MAE992'
    ],
    postRequisites: [],
    credits: 4.0,
    curriculum: '',
    difficultyLevel: '',
    evaluationStyle: '',
    teachers: '',
    advice: '',
    availability: '',
    schedule: ''
  }
]